/* © 2017-2026 Booz Allen Hamilton Inc. All Rights Reserved. */

import * as React from 'react';

import { LocationContent } from './LocationContent';
import { getSuggestionIcon } from './LocationSuggestion.utils';
import type { LocationSuggestionOptionType } from './LocationSuggestion.types';

import styles from './LocationSuggestion.module.scss';

export interface LocationSuggestionProps {
    /**
     * Suggestion object containing information about the location suggestion.
     */
    suggestion: LocationSuggestionOptionType;
    /**
     * The text used for searching or highlighting parts of the suggestion.
     * This is used to match and highlight relevant portions of the suggestion.
     */
    searchText: string;
}

export function LocationSuggestion({ suggestion, searchText }: LocationSuggestionProps) {
    return (
        <div className={styles.LocationSuggestion}>
            {suggestion.customRender ? (
                suggestion.customRender
            ) : (
                <>
                    <LocationIcon suggestion={suggestion} />

                    <LocationContent suggestion={suggestion} searchText={searchText} />
                </>
            )}
        </div>
    );
}

interface LocationIconProps {
    suggestion: LocationSuggestionOptionType;
}

export function LocationIcon({ suggestion }: LocationIconProps) {
    const icon = React.useMemo(() => {
        return getSuggestionIcon(suggestion);
        // Only change when suggestion is legit different
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [suggestion.id]);

    return <div className={styles.LocationIcon}>{icon}</div>;
}
